import React, { useContext, useEffect, useState } from 'react'

import { firestore } from '../../../firebase';

import StateContext from '../../../StateContext';
import BudgetCategoriesSelector from './BudgetCategoriesSelector';
import {dateInputFormatter} from '../../../helpers/dateFormatter'

function AddBudgetElement({type}) {

    const appState = useContext(StateContext)

    const [description, setDescription] = useState("");
    const [sum, setSum] = useState(0);
    const [category, setCategory] = useState();


    const dateInputFormatted = dateInputFormatter();

    const [date, setDate] = useState(dateInputFormatted)
    const [month, setMonth] = useState();
    const [year, setYear] = useState();

    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {

        if (date) {

            const dateBudget = new Date(date);
            const year = dateBudget.getFullYear();
            const month = dateBudget.getMonth()+1
            setYear(year);
            setMonth(month)

        }

    }, [date])

    async function addBudgetHandler(e) {
        e.preventDefault();
        try {
            const budgetRef = firestore.collection("users").doc(appState.userId).collection("budget");

            if (!sum || !category || !date) {
                setError("Du må fylle ut alle feltene");
                return
            }

            const dateBudget = new Date(date).toISOString();

            const data = {
                type: type,
                sum: +sum,
                description,
                category: category,
                date: dateBudget,
                month,
                year
            }
            budgetRef.add(data)
            setSum(0);
            setDescription("")
            setMessage("Post lagt til!")
        } catch (error) {
            setError("Noe gikk galt, prøv igjen")
        }
    }

    return (
        <form onSubmit={addBudgetHandler}>

            <h4 className="font-weight-bold my-4">Add {type}</h4>
            <label>Dato for {type}</label>
            <input type="date" className="form-control mb-2" value={date} onChange={e => setDate(e.target.value)} />

            <label>Beskrivelse</label>
            <textarea className="form-control mb-2" placeholder="Beskrivelse av budsjett" value={description} onChange={e => setDescription(e.target.value)} />
            <label>Sum</label>
            <input className="form-control mb-2" type="number" placeholder="Sum" value={sum} onChange={e => setSum(e.target.value)} />

            <p>Måned: {month ? month : ""}</p>
            <p>År: {year ? year : ""}</p>

            <BudgetCategoriesSelector category={category} setCategory={setCategory} type={type} />
            {error && <div onClick={() => setError("")} className="alert alert-danger">{error}</div>}
            {message && <div onClick={() => setMessage("")} className="alert alert-success">{message}</div>}
            <button className="btn btn-block btn-primary mt-3">Lagre</button>
        </form>
    )
}
export default AddBudgetElement